export default {"src":"/_next/static/media/plus.a0e5b1e8.svg","height":26,"width":26};